if (typeof FlashCard !== 'function') {
  class FlashCard extends HTMLElement {
    constructor() {
      super();
      this.overlay = this.querySelector('[data-overlay]');

      this.overlayLock = false;

      this.init();
    }

    init() {
      // this.addEventListener('mouseenter', this.showOverlay);
      // this.addEventListener('focus', this.showOverlay);

      // this.addEventListener('mouseleave', this.hideOverlay);
      // this.addEventListener('blur', this.hideOverlay);

      this.addEventListener('keydown', this.handleKeydown);
      this.addEventListener('click', this.toggleOverlayLock);
    }

    showOverlay() {
      if (!this.overlay) return;

      this.classList.add('display-overlay');
      this.overlay.setAttribute('visibility', 'visible');
    }

    hideOverlay() {
      if (this.overlayLocked) return;
      this.classList.remove('display-overlay');

      if (!this.overlay) return;
      this.overlay.setAttribute('visibility', 'hidden');
    }

    toggleOverlayLock() {
      this.overlayLocked = !this.overlayLocked;

      if (this.overlayLocked) {
        this.showOverlay(); // ensure it's visible when locked
      } else {
        this.hideOverlay(); // hide when unlocked
      }
    }

    handleKeydown(e) {
      // Enter or Space toggles just like a click
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault(); // prevent scrolling or accidental form submits
        this.toggleOverlayLock();
      }
    }
  }

  if (!customElements.get('flash-card')) {
    customElements.define('flash-card', FlashCard);
  }
}
